import { useState } from "react"
import { IoAddCircleOutline } from "react-icons/io5";
import { FiMinusCircle } from "react-icons/fi";
import { FaUser } from "react-icons/fa";


const UserItem = ({ property, allData, isPropertyOpen, setIsPropertyOpen }) => {

    return <>
        <div style={{ display: "flex", alignItems: "center", gap: 5 }} >
            {isPropertyOpen === property?._id ? <FiMinusCircle size={17} cursor={"pointer"} onClick={() => setIsPropertyOpen("")} /> : <IoAddCircleOutline size={19} cursor={"pointer"} onClick={() => setIsPropertyOpen(property?._id)} />}

            {property?.Name}
        </div>
        {isPropertyOpen === property?._id && (
            <>
                {allData.users && allData.users
                    .filter((user) => {
                        const findProperty = allData.property.find(
                            (property) => property._id === isPropertyOpen
                        );
                        return findProperty?.UserId.includes(user._id)
                    })
                    .map((user, index) => (
                        <div key={index} style={{ marginLeft: 20, display: "flex", alignItems: "center", gap: 5 }}>
                            <FaUser />
                            {user.customerId}
                        </div>
                    ))}
            </>
        )}
    </>
}


export default UserItem